/**
 * bodyClass
 */

import $ from 'jquery';

const hobex = {
    cfg: {
        container: document.getElementById('hobex'),
        checkout: document.getElementById('hobexCheckout'),
        cart: '',
        checkoutId: '',
        request: '',
        obj: '',
        status: '',
        sessionStart: null,
        sessionValid: 300000, // 1500000
        sessionTimeout: 1000,
        sessionInterval: ''
    },
    printContainer(checkoutId) {
        const url = `https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
        // eslint-disable-next-line
        console.log('checkoutId: ' + checkoutId);
        $.ajaxSetup({
            cache: true
        });

        $.getScript(url);

        // eslint-disable-next-line
        this.cfg.container.getElementsByTagName('form')[0].action = `https://obauer.com/de/shop/checkout/payment?checkoutId=${checkoutId}`;
    },
    sendHobexForm(obj) {
        // eslint-disable-next-line
        // console.log('sendHobexForm');
        // eslint-disable-next-line
        // console.log(obj);

        /* if (obj.card) {
            document.getElementById('hobexFirstName').setAttribute('value', obj.card.holder);
            document.getElementById('hobexLastName').setAttribute('value', obj.card.holder);
            document.getElementById('hobexMonth').setAttribute('value', obj.card.expiryMonth);
            document.getElementById('hobexYear').setAttribute('value', obj.card.expiryYear);
            document.getElementById('hobexCvv').setAttribute('value', obj.card.last4Digits);
            document.getElementById('hobexNumber').setAttribute('value', obj.card.bin);
        }   else if (obj.bankAccount) {
            document.getElementById('hobexFirstName').setAttribute('value', obj.bankAccount.holder);
            document.getElementById('hobexLastName').setAttribute('value', obj.bankAccount.holder);
            document.getElementById('hobexBankName').setAttribute('value', obj.bankAccount.bankName);
            document.getElementById('hobexIBAN').setAttribute('value', obj.bankAccount.iban);
            document.getElementById('hobexBIC').setAttribute('value', obj.bankAccount.bic);
            document.getElementById('hobexNumber').setAttribute('value', obj.bankAccount.number);
            document.getElementById('hobexBankCode').setAttribute('value', obj.bankAccount.bankCode);
            document.getElementById('hobexCountry').setAttribute('value', obj.bankAccount.country);
        } */

        document.hobexPaymentForm.submit();
    },
    displayReload() {
        this.cfg.container.innerHTML = `
            <div class="o-appContent__flashNotices">
                    <div class="bg-red-500 text-white">
                      <div class="container mx-auto px-6 py-4">
                          Ihre Session ist abgelaufen. Bitte laden Sie den Browser neu.
                      </div>
                  </div>
            </div>`;
        // Refresh Window
        // window.location.reload();
        // eslint-disable-next-line
        console.log('Reload Window');
    },
    init() {
        window.addEventListener('load', () => {
            if (this.cfg.container) {
                // eslint-disable-next-line
                fetch(`/assets/php/hobex.php?amount=${this.cfg.container.dataset.amount}&mid=${this.cfg.container.dataset.reference}`, {
                    method: 'get',
                    // may be some code of fetching comes here
                }).then((response) => {
                    // eslint-disable-next-line
                    console.log('Response Status: ' + response.status);
                    if (response.status >= 200 && response.status < 300) {
                        return response.text();
                    }
                    throw new Error(response.statusText);
                }).then((response) => {
                    this.cfg.obj = JSON.parse(response);
                    // eslint-disable-next-line
                    console.log('CheckoutID: ' + this.cfg.obj.id);

                    this.printContainer(this.cfg.obj.id);

                    // Set Session Time Start
                    this.cfg.sessionStart = new Date().getTime();
                    // Compare session
                    this.cfg.sessionInterval = setInterval(() => {
                        const timeNow = new Date().getTime();
                        const timeDiff = timeNow - this.cfg.sessionStart;
                        // eslint-disable-next-line
                        // console.log('Compare Session Diff: ' + timeDiff);

                        if (timeDiff > this.cfg.sessionValid) {
                            // eslint-disable-next-line
                            // console.log('Session abgelaufen: ' + timeDiff);
                            clearInterval(this.cfg.sessionInterval);
                            this.displayReload();
                        }
                    }, this.cfg.sessionTimeout);
                });
            } else if (this.cfg.checkout) {
                this.cfg.checkoutId = this.cfg.checkout.dataset.checkoutid;
                // eslint-disable-next-line
                console.log('CheckoutID: ' + this.cfg.checkoutId);
                fetch(`/assets/php/hobexStatus.php?checkoutId=${this.cfg.checkoutId}`, {
                    method: 'get',
                    // may be some code of fetching comes here
                }).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.text();
                    }
                    throw new Error(response.statusText);
                }).then((response) => {
                    this.cfg.status = JSON.parse(response);
                    // eslint-disable-next-line
                    console.log('Result: ');
                    // eslint-disable-next-line
                    console.log(this.cfg.status.result);
                    let success = false;

                    switch (this.cfg.status.result.code) {
                        case '000.000.000':
                            success = true;
                            break;
                        case '000.100.110':
                            success = true;
                            break;
                        default:
                            break;
                    }

                    if (success) {
                        this.sendHobexForm(this.cfg.status);
                    } else {
                        this.cfg.checkout.innerHTML = this.cfg.status.result.description;
                    }
                });
            }
        });
    }
};

export default hobex;



// WEBPACK FOOTER //
// ./___src/assets/js/scripts/hobex.js